import { render, staticRenderFns } from "./Limitions.vue?vue&type=template&id=2e9ba7fc&scoped=true"
import script from "./Limitions.vue?vue&type=script&lang=js"
export * from "./Limitions.vue?vue&type=script&lang=js"
import style0 from "./Limitions.vue?vue&type=style&index=0&id=2e9ba7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9ba7fc",
  null
  
)

export default component.exports